import Table from "../../Common/Table";
import Pagination from "../../Common/Pagination";
import useAddOrders from "./useAddOrders";

const AddOrder = () => {
  const {
    columns,
    currentRows,
    totalRows,
    currentPage,
    rowsPerPage,
    handlePageChange,
    handleRowsPerPageChange,
    loading
  } = useAddOrders();

  if (loading) return <p>Loading.....</p>

  return (
    <div className="p-4 flex flex-col">
      <div className="flex justify-between items-center">
        <h1 className="main_heading text-2xl xl:text-[30px] mb-3">Order</h1>
      </div>
      <div className="my-2 mb-6  text-green  overflow-auto horizontalscroll">
        <Table className="bg-green50" columns={columns} data={currentRows} />
      </div>
      <Pagination
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />
    </div>
  );
};

export default AddOrder;